module.exports = __webpack_public_path__ + "img/ca44792.png";